import { ValidationError } from "@angular/forms/signals"

export const PATCH_IGNORED_FIELDS = [
    "_id",
    "id",
    "masterId",
    "createdByUser",
    "modifiedByUser",
    "createdDate",
    "modifiedDate",
    "version",
    "level",
]

export function describeError(err: any): { message: string; incorrectFields: string[] } {
    if (typeof err?.error === "string") {
        return { message: err.error, incorrectFields: [] }
    }
    if (typeof err?.error === "object" && err.error?.message) {
        return { message: err.error.message, incorrectFields: err.error.incorrectFields ?? [] }
    }
    return { message: "Došlo je do pogreške.", incorrectFields: [] }
}

export function toErrors<T extends Record<string, boolean>>(incorrectFields: string[], empty: T): T {
    const errors = { ...empty }
    const wrong = incorrectFields.map(f => f.toLowerCase())
    for (const key of Object.keys(errors)) {
        ;(errors as Record<string, boolean>)[key] = wrong.includes(key.toLowerCase())
    }
    return errors
}
type FormFieldNode = () => { invalid: () => boolean }

export type FormFields = Iterable<[string, FormFieldNode | undefined]>

export interface ServerFieldErrors {
    detail: string
    errors: ValidationError.WithOptionalFieldTree[]
}

function detail(labels: string[], fallback: string): string {
    return labels.length ? `Provjerite obavezna polja: ${labels.join(", ")}.` : fallback
}
export function toServerFieldErrors(
    err: unknown,
    form: FormFields,
    labels: Record<string, string>
): ServerFieldErrors {
    const { message, incorrectFields } = describeError(err)
    const wanted = incorrectFields.map(field => field.toLowerCase())

    const matched: { key: string; field: FormFieldNode }[] = []
    for (const [key, field] of form) {
        if (field && wanted.includes(key.toLowerCase())) matched.push({ key, field })
    }
    if (!matched.length) {
        return { detail: message, errors: [] }
    }

    return {
        detail: detail(matched.map(({ key }) => labels[key] ?? key), message),
        errors: matched.map(({ field }) => ({
            kind: "server",
            fieldTree: field as unknown as ValidationError.WithOptionalFieldTree["fieldTree"],
        })),
    }
}
export function invalidFieldsDetail(form: FormFields, labels: Record<string, string>): string {
    const invalid: string[] = []
    for (const [key, field] of form) {
        if (field?.().invalid()) invalid.push(labels[key] ?? key)
    }

    return detail(invalid, "Provjerite unesene podatke.")
}
